{
    "wishlist": {
        "empty": "Er staan geen artikelen in uw verlanglijst."
    }
}